<template>
  <div>
    <DiagnosticImageFilter
      v-if="$can('filter', 'diagnostic-images')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable titleTable="Diagnostic Images" iconTable="fas fa-disease" />
      <div class="m-1">
        <DiagnosticImageEdit
          v-if="isEditDiagnosticImageSidebarActive"
          :is-edit-diagnostic-image-sidebar-active.sync="
            isEditDiagnosticImageSidebarActive
          "
          :itemEdit="itemEdit"
          :optionsCategories="optionsCategories"
          @editDiagnosticImageSuccess="editDiagnosticImageSuccess"
        />
        <DiagnosticImageAdd
          v-if="isAddNewDiagnosticImageSidebarActive"
          :optionsCategories="optionsCategories"
          :is-add-new-diagnostic-image-sidebar-active.sync="
            isAddNewDiagnosticImageSidebarActive
          "
          @createDiagnosticImage="createDiagnosticImage"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'diagnostic-images')"
                variant="primary"
                @click="isAddNewDiagnosticImageSidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} Diagnostic Images</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative min-height-table"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="$can('update', 'diagnostic-images')"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editDiagnosticImage(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'diagnostic-images')"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteDiagnosticImage(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/api/admin/consults/diagnosticImages";
import axiosDC from "@/core/services/api/admin/consults/diagnosticImagesCategories";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import DiagnosticImageEdit from "./DiagnosticImageEdit.vue";
import DiagnosticImageAdd from "./DiagnosticImageAdd.vue";
import DiagnosticImageFilter from "./DiagnosticImageFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    DiagnosticImageEdit,
    DiagnosticImageAdd,
    DiagnosticImageFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "id",
        { key: "name", label: "Name", sortable: true },
        'price_cost',
        { key: "price", label: "Price", sortable: true },
        {
          key: "category_diagnostic_imagings.name",
          label: "Category",
          sortable: true,
        },
        { key: "status", label: "Status" },
        // A virtual column made up from two fields
        { key: "actions", label: "Actions" },
      ],
      items: null,
      optionsCategories: [],
      loading: false,
      isEditDiagnosticImageSidebarActive: false,
      isAddNewDiagnosticImageSidebarActive: false,
      itemEdit: null,
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      diagnosticImageFilter: null,
    };
  },
  mounted() {
    this.getDiagnosticImage();
    axiosDC.diagnosticImageCategoryList(20).then(({ data }) => {
      this.optionsCategories = data;
    });
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getDiagnosticImage();
      } else {
        this.searchFilter(this.diagnosticImageFilter);
      }
    },
  },
  methods: {
    getDiagnosticImage() {
      axiosAC
        .diagnosticImageList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editDiagnosticImage(item) {
      this.isEditDiagnosticImageSidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editDiagnosticImageSuccess(value) {
      if (value) {
        this.$refs.toast.success("Type DiagnosticImage updated successfully");
      } else {
        this.$refs.toast.error("Error updating type diagnostic-image");
      }
      this.isEditDiagnosticImageSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createDiagnosticImage({ status }) {
      if (status) {
        this.$refs.toast.success("DiagnosticImage type added successfully");
      } else {
        this.$refs.toast.danger("DiagnosticImage type not added");
      }
      this.isAddNewDiagnosticImageSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteDiagnosticImage(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.diagnosticImageDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "DiagnosticImage type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .diagnosticImagePagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .diagnosticImageFilterPagination(
            this.perPage,
            page,
            this.diagnosticImageFilter
          )
          .then(({registro:{ data, total, current_page, ...res }}) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.diagnosticImageFilter = value;
        axiosAC
          .diagnosticImageFilter(this.perPage, value)
          .then(({registro:{ data, total, current_page, ...res }}) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getDiagnosticImage();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
